







import Vue, { PropType } from 'vue'
import { ScriptStatus } from '@/constants/scripts'

export default Vue.extend({
  props: {
    status: {
      type: Number as PropType<ScriptStatus>,
      required: true,
    },
  },

  computed: {
    titleText(): string {
      switch (this.status) {
        case ScriptStatus.Unpublish:
          return 'Не опубликовано'
        case ScriptStatus.Publish:
          return 'Опубликовано'
      }
      return ''
    },

    tooltipClasses(): string {
      return 'tooltip-status-' + this.status
    },
  },
})
